import type { IAccountMetadata, IPortfolioMetadata } from "@pulse-ui/codegen/generated_ts/org_metadata";
import type { ISelectOption } from "@pulse-ui/types/components/DropdownInput";
import { DropdownInput } from "@/components/Inputs";

interface BlotterHeaderProps {
  selectedPortfolio: IPortfolioMetadata | null;
  selectedAccount: IAccountMetadata | null;
  portfolioOptions: ISelectOption[];
  accountOptions: ISelectOption[];
  onPortfolioChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onAccountChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

/**
 * BlotterHeader component displays the page title and portfolio/account selectors.
 *
 * Layout:
 * - Left: "Blotter" title
 * - Right: Portfolio and Account dropdown inputs
 */
const BlotterHeader = ({
  selectedPortfolio,
  selectedAccount,
  portfolioOptions,
  accountOptions,
  onPortfolioChange,
  onAccountChange,
}: BlotterHeaderProps) => {
  return (
    <div className="pulse-row blotter-header-row">
      <p className="pulse-typography-headline-6 pulse-color--background-50">Blotter</p>
      <div className="blotter-dropdown-inputs-container">
        <DropdownInput
          name="portfolio-select"
          value={selectedPortfolio?.portfolio_id || ""}
          label="Portfolio"
          onChange={onPortfolioChange}
          disabled={portfolioOptions.length < 1}
          options={portfolioOptions}
          formInput={false}
          containerClassNames=""
        />
        <DropdownInput
          name="account-select"
          value={selectedAccount?.account_id || ""}
          label="Account"
          onChange={onAccountChange}
          disabled={
            selectedPortfolio?.accounts
              ? selectedPortfolio.accounts.length < 1
              : true
          }
          options={accountOptions}
          formInput={false}
          containerClassNames=""
        />
      </div>
    </div>
  );
};

export default BlotterHeader;
